import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr'
import {
  Typography,
  Row,
  Col,
  Button,
  Rate,
  Select
} from 'antd';
import { openLoginModel, getReviewsAction } from '../../store/actions'
import LeaveReviewModel from '../../modals/reviews/LeaveReviewModel'
import { renderRatings } from '../classified-templates/CommanMethod'
import ReviewList from './ReviewList'
import { PAGE_SIZE, REVIEW_TYPE, SORT_REVIEW_BY } from '../../config/Config';
const { Title } = Typography;
const { Option } = Select;

class ProductReviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewModel: false,
      isFilter: false,
      filteredData: [],
      isUserExits: false,
      isUserLoggedIn: false,
      allStarData: [],
      reviewData: [],
      value: 5,
      is_user_reviewed: 0,
      total_reviews: 0,
      average_rating: 0,
      rating_counts: "",
      reviewList: "",
      order_by: SORT_REVIEW_BY.NEWEST_FIRST,
      per_page: PAGE_SIZE.PAGE_SIZE_10,
      page: 1,
    };
  }

  /**
   * @method componentWillReceiveProps
   * @description receive props
   */
  componentWillReceiveProps(nextprops, prevProps) {
    let updatedList = nextprops.classifiedDetail
    this.handleRatingChange(updatedList)
    this.checkReviewAdded()
  }

  /**
 * @method componentWillMount
 * @description get selected categorie details
 */
  componentWillMount() {
    const { isLoggedIn } = this.props
    this.setState({ isUserLoggedIn: isLoggedIn })
    let data = this.props.classifiedDetail
    this.getReviewsList();
    if (data) {
      this.setState({ reviewData: data.classified_hm_reviews })
      this.checkReviewAdded()
    }
  }



  getReviewsList = () => {
    const { order_by, per_page, page } = this.state;
    const product_id = this.props.classifiedDetail?.id
    let reqData = {
      module: REVIEW_TYPE.PRODUCT,
      product_id, page,
      order_by, per_page
    }
    this.props.getReviewsAction(reqData, (res) => {
      if (res.success) {
        const { is_user_reviewed, rating_counts, reviews } = res.data
        const reviews_counts = rating_counts.map(count => Number(count.count));
        const total_reviews = reviews_counts.reduce((a, b) => a + b, 0)
        const total_rating = rating_counts.map(rate => Number(rate.rating)).reduce((a, b) => a + b, 0)
        const average_rating = total_rating ? total_rating / rating_counts.length : 0
        this.setState({ reviewList: reviews, is_user_reviewed, rating_counts, total_reviews, average_rating })
      }

    })
  }


  checkReviewAdded = () => {
    const { isLoggedIn, loggedInUser, classifiedDetail } = this.props
    let hmReview = classifiedDetail && classifiedDetail.classified_hm_reviews && Array.isArray(classifiedDetail.classified_hm_reviews) && classifiedDetail.classified_hm_reviews.length ? classifiedDetail.classified_hm_reviews : []
    if (isLoggedIn && hmReview && hmReview.length) {
      hmReview.some((el) => {
        if (el.user_id === loggedInUser.id) {
          this.setState({ isUserExits: true, reviewModel: false })
        }
      });
    }
  }


  /**
     * @method contactModal
     * @description contact model
     */
  leaveReview = () => {
    const { classifiedDetail, loggedInUser, isLoggedIn } = this.props
    let hmReview = classifiedDetail && classifiedDetail.classified_hm_reviews && Array.isArray(classifiedDetail.classified_hm_reviews) && classifiedDetail.classified_hm_reviews.length ? classifiedDetail.classified_hm_reviews : []
    if (isLoggedIn) {
      if (classifiedDetail.is_confirmed_purchase === 0) {
        toastr.warning('warning', 'Please confirm your purchase before adding review.')
        this.setState({ isUserExits: true, reviewModel: false })
      } else if (hmReview && hmReview.length) {
        hmReview.some((el) => {
          if (el.user_id === loggedInUser.id) {
            this.setState({ isUserExits: true, reviewModel: false })
            toastr.warning('warning', 'You have already added your review.')
          } else {
            this.setState({ isUserExits: false, reviewModel: true })
          }
        });
      } else if (hmReview.length === 0) {
        this.setState({ isUserExits: false, reviewModel: true })
      }

    } else {
      this.props.openLoginModel()
    }
  };

  /**
   * @method handleCancel
   * @description handle cancel
   */
  handleCancel = e => {
    this.setState({
      reviewModel: false,
    });
  };


  /**
    * @method handleRatingChange
    * @description handle rating change
    */
  handleRatingChange = (list) => {
    const data = list.classified_hm_reviews ? list.classified_hm_reviews : [];
    this.setState({
      reviewData: data
    })
  }


  /**
  * @method likeReviewCallback
  * @description like this review
  */
  likeReviewCallback = () => {
    this.getReviewsList()
  }

  /**
  * @method filterRating
  * @description filter rating
  */
  filterRating = (list) => {
    return (
      <Select
        defaultValue={SORT_REVIEW_BY.MOST_RECENT}
        size='large'
        className='w-100 shadow-select-automotive'
        onChange={(e) => { this.setState({ order_by: e }, () => this.getReviewsList()) }}
      >
        <Option value={SORT_REVIEW_BY.MOST_RECENT}>Show: <strong>Most Recent</strong></Option>
        <Option value={SORT_REVIEW_BY.TOP_RATED}>Show: <strong>Top Rated</strong></Option>
      </Select>
    )
  }



  /**
   * @method render
   * @description render component
   */
  render() {
    const { reviewModel, rating_counts, reviewList, reviewData, total_reviews, average_rating } = this.state;
    const { classifiedDetail } = this.props;
    let rateLabel = '';
    if (average_rating > 4) {
      rateLabel = 'Excelent'
    } else if (average_rating > 3) {
      rateLabel = 'Good'
    } else if (average_rating > 2) {
      rateLabel = 'Average'
    } else if (average_rating > 1) {
      rateLabel = 'Poor'
    } else if (average_rating > 0) {
      rateLabel = 'Terrible'
    }

    return (
      <Row gutter={[20, 20]}>
        <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }}>
          <h4 className='tabTitle'>Customer Reviews</h4>
          <div className='reviewsRating'>
            <h5 className='subTitle'>
              <strong>Rating Snapshop</strong>
              {/* Select a row below to filter results */}
            </h5>
            <div className='ratingSection'>
              <div className='ratingNo'>
                {average_rating ? <Title level={3} className="ratingTitle"> {average_rating} </Title> : <Title level={4} className="noReviewText">No Review Yet</Title>}
              </div>
              <div className='ratingDetail'>
                <Rate disabled value={average_rating ? Math.round(average_rating) : '0'} />
                <div className="ratingFigure">
                  {rateLabel !== '' && rateLabel}{" "}
                  <strong>{average_rating ? average_rating : '0'}</strong>  of 5.0 from{" "}
                  {total_reviews} reviews
                </div>
              </div>
            </div>
            <hr style={{ margin: "10px 0 30px" }} />
            <div className='reviewsRatingStatus'>
              {rating_counts && renderRatings(rating_counts, total_reviews)}
              <hr style={{ margin: "30px 0" }} />
              <Button type='default'
                className={this.state.isUserLoggedIn ? 'w-100 leave-review-btn' : 'w-100 disabled'}
                onClick={this.leaveReview}
                disabled={this.state.isUserLoggedIn ? false : true}
              // disabled={isUserExits ? true : false}
              >Leave a Review</Button>
            </div>
          </div>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 1 }} lg={{ span: 2 }}>
          &nbsp;
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 14 }} className="classified-all-review pl-75">
          <Row gutter={0} align="middle" style={{ marginBottom: "40px" }}>
            <Col md={14}>
              <h4 className='tabTitle'>
                {`Reviews (${reviewList?.total ?? 0})`}
              </h4>
            </Col>
            <Col md={3}></Col>
            <Col md={7}>
              {this.filterRating(classifiedDetail)}
            </Col>
          </Row>
          <ReviewList
            userList={reviewData}
            likeReviewCallback={this.likeReviewCallback}
            getReviewsList={() => this.getReviewsList()}
            reviewList={this.state.reviewList}
            reviewpage={this.state.page}
            classifiedDetail={classifiedDetail}
          />


          {reviewModel &&
            <LeaveReviewModel
              visible={reviewModel}
              module={REVIEW_TYPE.PRODUCT}
              onCancel={this.handleCancel}
              classifiedDetail={classifiedDetail && classifiedDetail}
              callNext={() => this.getReviewsList()}
            />}
        </Col>
      </Row>
    );
  }
}

//  Connect with redux through connect methode
const mapStateToProps = (store) => {
  const { auth: { loggedInUser, isLoggedIn } } = store;
  return { loggedInUser, isLoggedIn };
};

export default connect(mapStateToProps, { openLoginModel, getReviewsAction })(ProductReviews);
